/**
 * FriendSuggestionsCard - Shows prompts suggested by friends, grouped by sender.
 *
 * Displays a list of friends who have suggested prompts, with counts of
 * answered and pending (unanswered) suggestions. Clicking a row navigates
 * to the friend-suggestions category with the best target prompt selected.
 */

import React from 'react';

function FriendSuggestionsCard({ friendSuggestions, onNavigate }) {
  if (!friendSuggestions || friendSuggestions.length === 0) return null;

  return (
    <div className="bento-card bento-card--small">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">💌</span>
          Suggestions from Friends
        </h2>
      </div>
      <div className="shared-with-me-list">
        <div className="shared-with-me-header">
          <span className="shared-header-name">From</span>
          <span className="shared-header-total">Done</span>
          <span className="shared-header-new">Pending</span>
        </div>
        {friendSuggestions.map(fs => (
          <div
            key={fs.username}
            className="shared-with-me-item"
            onClick={() => onNavigate(fs.targetPromptId)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onNavigate(fs.targetPromptId);
              }
            }}
          >
            <span className="shared-username">{fs.username}</span>
            <span className="shared-total-count">{fs.answeredCount}</span>
            <span className={`friend-sugg-pending ${fs.unansweredCount > 0 ? 'has-pending' : ''}`}>
              {fs.unansweredCount > 0 ? fs.unansweredCount : '—'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FriendSuggestionsCard;
